<template>
  <header class="header-page">
    <nav>
      <div class="logo-box">
        <img class="logo" src="@/assets/logo.png" alt="logo" @click="goHome" />
        <!-- <svg
          viewBox="0 0 24 24"
          width="32"
          height="32"
          stroke="currentColor"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
          shape-rendering="geometricPrecision"
          class="divider"
        >
          <path d="M16.88 3.549L7.12 20.451"></path>
        </svg> -->
      </div>
      
      <div class="user-info-box">
        <company-selector />
        <div class="message" v-if="!userData.isSuperMan">
          <el-dropdown trigger="click" @visible-change="checkMessageTag" placement="bottom-end">
            <el-badge :value="store.state.notify.unread" :max="99">
              <i class="el-icon-message-solid" />
            </el-badge>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item v-for="(item, index) in notifyList" :key="index" class="message-items" @click="goToMessage(item.type)">
                  <div class="onMessage" v-if="item.message.length > 0">
                    <div class="onMessage_data">
                      <img v-if="item.content && item.content.applicationIcon" :src="item.content.applicationIcon" mode="heightFix" />
                      <img v-else :src="NOTIFY_TYPE[item.type].icon" mode="heightFix" />
                      <div class="top">
                        <div class="lable">
                          <el-badge :value="item.state != 0 ? item.state : null" :max="99">
                            <text>
                              {{ NOTIFY_TYPE[item.type].label }}
                            </text>
                          </el-badge>
                        </div>
                        <div class="time">
                          {{ timeChange(item.message[item.message.length - 1].dateTime) }}
                        </div>
                      </div>
                    </div>
                    <div class="down">
                      {{ item.message[item.message.length - 1].content.body }}
                    </div>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item disabled>
                  <div class="empty">无更多未读消息</div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
        <el-dropdown trigger="click">
          <div class="user-box">
            <!-- <el-avatar v-if="userData.userIcon" class="img" shape="circle" :size="35" :src="userData.userIcon" /> -->
            <!-- <span v-else class="avatar">{{ userData.userName.slice(0, 1).toUpperCase() }}</span> -->
            <div class="own-info">
              <span>
                {{ userData.userName }}
              </span>
            </div>
            <i class="el-icon-arrow-down el-icon--right" />
          </div>

          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item class="dropdown-items" @click="router.push('/accountCenter')">基本信息 </el-dropdown-item>
              <el-dropdown-item class="dropdown-items" @click="router.push('/myTeam')" divided>我的企业 </el-dropdown-item>
              <!-- <el-dropdown-item class="dropdown-items" @click="router.push('/interestsInfo')" >我的权益
              </el-dropdown-item> -->
              <el-dropdown-item class="dropdown-items" @click="onOpenMyOrder">我的订单 </el-dropdown-item>
              <el-dropdown-item class="dropdown-items" @click="jumpToReportPage" divided>我的报表 </el-dropdown-item>
              <el-dropdown-item class="dropdown-items" @click="opendrawer()">我的推荐人 </el-dropdown-item>
              <el-dropdown-item class="dropdown-items" @click="openInviteDialog">获取受邀课程 </el-dropdown-item>
              <el-dropdown-item class="dropdown-items" @click="router.push('/myCertificate')">我的证书 </el-dropdown-item>
              <el-dropdown-item class="dropdown-items" @click="toHelpCenter">帮助中心 </el-dropdown-item>
              <el-dropdown-item class="dropdown-items" @click="onSignOut" divided> 退出登录 </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </nav>

    <PeopleData ref="peopleDataRef" />
    <inviteCodeDialog ref="inviteCodeRef" />
  </header>
</template>
<script setup>
const helpCenterUrl = process.env.VUE_APP_SAFE_HELP_CENTER_URL;
import inviteCodeDialog from "@/views/common/inviteCodeDialog/index.vue";
import companySelector from "@/components/company-selector/index.vue";
import { logout } from "@/http/api/workbench";
import { isUrlWithParam } from "@/utils";
import { ref, computed, getCurrentInstance, watch } from "vue";
import PeopleData from "./peopleData.vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import { ElMessageBox } from "element-plus";

const { proxy } = getCurrentInstance();
const router = useRouter();
let store = useStore();
let route = useRoute();

const peopleDataRef = ref(null);
const inviteCodeRef = ref(null);
// 数据

let currentPath = ref(null);
let notifyList = ref([
  { type: "N000", message: [], state: 0 }, //应用通知
  { type: "N001", message: [], state: 0 }, //系统通知
  { type: "N002", message: [], state: 0 }, //工作台助手
  { type: "N003", message: [], state: 0 }, //活动通知
  { type: "N004", message: [], state: 0 }, //订单权益
  { type: "N005", message: [], state: 0 }, //上新通知
  { type: "N006", message: [], state: 0 } //文件助手
]); //左侧列表消息

let userData = computed(() => {
  return store.state.auth.userData;
});
let isCurrentCompany = computed(() => {
  return store.getters["auth/currentCompany"];
});
let isAdmin = computed(() => {
  if (isCurrentCompany.value.companyId == -1) {
    return false;
  } else {
    return store.getters["auth/isAdmin"];
  }
});
const NOTIFY_TYPE = computed(() => {
  return proxy.$constant.NOTIFY_TYPE;
});

// 监听
watch(
  route,
  (nVal) => {
    currentPath.value = nVal.path;
  },
  { immediate: true }
);

//退出登录
function onSignOut() {
  ElMessageBox.alert("确定退出吗？", "提示", {
    cancelButtonText: "取消",
    showCancelButton: true,
    type: "warning",
    callback: async (action) => {
      console.log(action);
      if (action === "confirm") {
        try {
          await logout({
            clientId: "10006",
            refreshToken: store.state.auth.refreshToken
          });
        } catch (error) {
          console.log(error);
        }
        localStorage.clear();
        store.commit("auth/clear");
        router.replace("/login");
      }
    }
  });
}

const goHome = () => router.push("/");

//我的报表
const jumpToReportPage = () => router.push("/report");

//我的邀请码
const opendrawer = () => {
  peopleDataRef.value.changedrawer();
};

//受邀课
function openInviteDialog() {
  inviteCodeRef.value.dialogVisible = true;
}

//我的订单
const onOpenMyOrder = () => {
  router.push("/myorder");
  // let url = process.env.VUE_APP_SAFE_CLIENT_MYORDER;
  // const spacer = isUrlWithParam(url) ? "&" : "?";
  // window.open(
  //   `${url}${spacer}companyId=${localStorage.getItem("currentCompany")}&token=${localStorage.getItem("token")}&userAccountId=${
  //     store.state.auth.userData.userAccountId
  //   }&auditPerson=${store.state.auth.userData.userName}`
  // );
};

//跳转帮助中心
const toHelpCenter = () => {
  window.open(helpCenterUrl);
};

//↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓消息↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓//
//消息tag选择
const checkMessageTag = async (value) => {
  if (!value) return;
  let tools; //当前用户的消息
  tools = await store.dispatch("notify/getAllNotifyList");

  // 由于只差当前用户的消息，所以只会有一个人，进行根据时间排序，显示最新的那条
  let findTimeTools = tools.sort((a, b) => {
    return new Date(a.dateTime).getTime() > new Date(b.dateTime).getTime()
      ? 1
      : new Date(a.dateTime).getTime() < new Date(b.dateTime).getTime()
      ? -1
      : 0;
  });

  notifyList.value = [
    { type: "N000", message: [], state: 0 }, //应用通知
    { type: "N001", message: [], state: 0 }, //系统通知
    { type: "N002", message: [], state: 0 }, //工作台助手
    { type: "N003", message: [], state: 0 }, //活动通知
    { type: "N004", message: [], state: 0 }, //订单权益
    { type: "N005", message: [], state: 0 }, //上新通知
    { type: "N006", message: [], state: 0 } //文件助手
  ];

  findTimeTools.forEach((item) => {
    notifyList.value.forEach((item2) => {
      if (item2.type == item.type) {
        item2.message.push(item);
        if (item.state != "0") {
          item2.state++;
        }
      }
    });
  });

  notifyList.value.forEach((item) => {
    if (item.state == 0) {
      item.message = [];
    }
  });
};
//消息选择
const goToMessage = (type) => {
  router.push({
    path: "/information",
    query: {
      type: type
    }
  });
};
//计算时间
const timeChange = (data1) => {
  if (data1) {
    let dateBegin = new Date(data1.replace(/-/g, "/"));
    let dateEnd = Date.now();

    let dateDiff = dateEnd - dateBegin.getTime(); //时间差的毫秒数
    let dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)) + 1; //计算出相差天数
    if (dayDiff > 30) {
      return data1.split(" ")[0];
    } else if (dayDiff == 1) {
      if (Math.floor(dateDiff / (3600 * 1000)) == 0) {
        if (Math.floor(dateDiff / (60 * 1000)) == 0) {
          return "刚刚";
        } else {
          return Math.floor(dateDiff / (60 * 1000)) + "分钟前";
        }
      } else {
        return Math.floor(dateDiff / (3600 * 1000)) + "小时前";
      }
    } else {
      return dayDiff + "天前";
    }
  }
};
//↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑消息↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑//
</script>
<style lang="scss" scoped>
.header-page {
  width: 100%;

  ::v-deep(.el-drawer__header) {
    background: linear-gradient(90deg, #ff6a00 0%, #f5a874 100%);
    margin-bottom: 0px;
    padding-bottom: 20px;

    .el-drawer__close-btn {
      i {
        color: #fff;
      }
    }
  }

  user-select: none;
  height: 70px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid $border-color-common;

  nav {
    width: 1440px;
    max-width: 1440px;
    margin: 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
  }

  .logo-box {
    display: flex;
    align-items: center;

    .current-com-box {
      border-left: 1px solid $border-color-dark;
      padding-left: 23px;
      margin-left: 23px;
    }

    .logo {
      cursor: pointer;
      width: 160px;
    }

    .divider {
      margin: 0 23px;
      color: #eaeaea;
    }
  }

  .user-box {
    display: inline-flex;
    align-items: center;

    .avatar {
      margin-right: 10px;
      width: 35px;
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $text-color-orange;
      color: #fff;
      font-size: 16px;
      line-height: 32px;
      border-radius: 50%;
    }

    .own-info {
      cursor: pointer;
      font-size: 16px;
      margin-left: 10px;
    }
  }
}

.dropdown-items {
  width: 140px;
  line-height: 50px;
  text-align: center;
  overflow: hidden;
}

.el-dropdown-menu {
  max-height: 600px;
}

.message-items {
  width: 320px;
  text-align: center;
  overflow: hidden;

  .onMessage {
    margin: 10px;
    display: flex;
    flex-direction: column;

    &_data {
      line-height: 50px;
      margin-left: 10px;
      flex: 1;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      img {
        border-radius: 50%;
        height: 25px;
        width: 25px;
      }

      .top {
        margin-left: 10px;
        width: 100%;
        display: flex;
        justify-content: space-between;

        .lable {
          font-weight: bold;

          .el-badge {
            width: 100%;

            ::v-deep(.el-badge__content) {
              height: 15px;
              width: 15px;
              line-height: 15px;
              padding: 0px 0px;
              top: 24px;
              right: -5px;
              background: red;
            }
          }
        }

        .time {
          color: #091b3d;
          opacity: 0.4;
          height: 100%;
          display: flex;
          align-items: flex-end;
        }
      }
    }

    .down {
      line-height: 25px;
      width: 100%;
      overflow: hidden;
      white-space: normal;
      word-wrap: break-word;
      word-break: break-all;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
}

.empty {
  text-align: center;
}

.user-info-box {
  display: flex;
  align-items: center;
  height: 100%;

  .message {
    height: 100%;
    display: flex;
    align-items: center;
    margin-right: 15px;

    .el-badge {
      ::v-deep(.el-badge__content) {
        height: 15px;
        width: 15px;
        line-height: 15px;
        padding: 0px 0px;
        top: 5px;
        right: 8px;
        background: red;
      }
    }

    .el-icon-message-solid {
      cursor: pointer;
      color: #bec1cf;
      font-size: 20px;

      margin-top: 5px;
    }
  }
}
</style>
